import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../components/Header";
import LeftSidebar from "../components/LeftSidebar";
import RightSidebar from "../components/RightSidebar";
import SearchOverlay from "../components/SearchOverlay";
import Pagination from "../components/Pagination";
import Logo from "../components/Logo";
import Footer from "../components/Footer";
import { setCurrentCategory } from "../store/pageSlice";
import ProductItems from "../components/ProductItems";

function CategoryPage() {
  const dispatch = useDispatch();

  // URL 파라미터 값
  const { category } = useParams(); // fingers, hair, necklace 등등

  // Redux에서 검색창 열림 여부 가져오기
  const isSearchOpen = useSelector((state) => state.search.isSearchOpen);

  // 페이지 진입 시 카테고리 설정 + 첫 페이지로 초기화
  useEffect(() => {
    dispatch(setCurrentCategory(category));
  }, [category, dispatch]);

  return (
    <div className="wrapper">
      {/* 검색창 */}
      {isSearchOpen && <SearchOverlay />}

      {/* 헤더 */}
      <Header />
      {/* 컨테이너 시작 */}
      <div className="container">
        {/* 왼쪽 aside */}
        <LeftSidebar />

        {/* 중앙 메인 콘텐츠 */}
        <main>
          <Logo />

          {/* items */}
          <ProductItems category={category} />

          {/* pages */}
          <Pagination />

          {/* Footer */}
          <Footer />
        </main>

        {/* 우측 aside */}
        <RightSidebar />
      </div>
    </div>
  );
}

export default CategoryPage;
